import {
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core'
import { CatalogueEntry, CatalogueService, Field, StoredEntityService } from '@dot-it/jml-lib'
import { Observable, of } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { EntityReference } from '../../../../models/entity-reference'

@Component({
  selector: 'jml-lib-multiselect-wrapper',
  templateUrl: './multiselect-wrapper.component.html',
  styleUrls: ['./multiselect-wrapper.component.scss']
})
export class MultiselectWrapperComponent implements OnInit, OnChanges {
  @Input() staticOptions?: CatalogueEntry[]
  @Input() tableReference: ElementRef
  @Input() editable = false
  @Input() rowData: any
  @Input() field: Field
  @Input() dtoType: string
  @Input() entityId: number
  @Input() customEdit = false

  @Output() completeCellEdit: EventEmitter<any> = new EventEmitter()
  @Output() onCustomEdit: EventEmitter<any> = new EventEmitter()

  options$: Observable<CatalogueEntry[]>
  selectedEntries: CatalogueEntry[] = []

  private catalogueService = inject(CatalogueService)
  private storedEntityService = inject(StoredEntityService)

  ngOnInit(): void {
    this.loadOptions()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.rowData) {
      this.setSelectedValue(this.rowData[this.field.field])
    }
  }

  private loadOptions(): void {
    if (this.field?.catalogueExpression) {
      this.options$ = this.loadCatalogueByExpression()
    } else if (this.staticOptions) {
      this.options$ = of(this.staticOptions)
    } else {
      this.options$ = this.loadCatalogue()
    }
  }

  setSelectedValue(entries: CatalogueEntry[]) {
    this.selectedEntries = Array.isArray(entries) ? entries : []
  }

  private loadCatalogueByExpression(): Observable<CatalogueEntry[]> {
    const reference = new EntityReference(this.dtoType, this.entityId)

    return this.storedEntityService.getEntity$(this.dtoType, this.entityId).pipe(
      switchMap((_) => this.catalogueService.getCatalogueByExpression(this.field.catalogueExpression, reference)),
      map((catalogue) => (!catalogue?.values ? [] : catalogue?.values))
    )
  }

  private loadCatalogue(): Observable<CatalogueEntry[]> {
    return this.catalogueService.getCatalogue(this.field.defaultCatalogue).pipe(map((catalogue) => catalogue.values))
  }

  emitComplete(event: any) {
    this.completeCellEdit.emit({ value: event.value ?? [] })
  }

  emitOnCustomEdit() {
    this.onCustomEdit.emit()
  }
}
